// hooks/usePreventPopState.ts
import { onBeforeUnmount, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import {
    SimplePopUp,
    SimplePopUpBtnType,
    SimplePopUpModalType,
    SimplePopUpSize
} from '@/libs/SimplePopUp';
import router from '@/router';
import { RouteUrlList } from '@/libs/RouteList';
import { useEsunMB } from '@/composables/useEsunMB';

export function usePreventPopState() {
    const router = useRouter();
    const handleGoBack = (event: PopStateEvent) => {
        event.preventDefault(); // 阻止返回
        // 每次 popstate 發生時都推送當前頁面的狀態，防止返回
        history.pushState(null, '', location.href);

        const simplePopUp = new SimplePopUp();
        simplePopUp
            .showAlert(SimplePopUpModalType.Info, '提示訊息', '確定要離開流程嗎？', [
                {
                    id: 'cancel',
                    type: SimplePopUpBtnType.callback,
                    btnClass: 'btn-secodary ',
                    resolveParam: 'cancel',
                    title: '取消'
                },
                {
                    id: 'confirm',
                    type: SimplePopUpBtnType.callback,
                    btnClass: 'btn-info',
                    resolveParam: 'confirm',
                    title: '確定'
                }
            ])
            .then((action: string) => {
                if (action === 'confirm') {
                    const { isAppEmbedded, closeWebView } = useEsunMB();
                    if (isAppEmbedded.value) {
                        closeWebView();
                    } else {
                        router.replace({ name: RouteUrlList.Login.name });
                    }
                }
            });
    };
    onMounted(() => {
        window.addEventListener('popstate', handleGoBack);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('popstate', handleGoBack);
    });
}
